const config = {
  api: {
    url: 'http://localhost:3222/v1',
  },
  cms: {
    url: 'http://localhost:7777',
  },
  s3: {
    url: 'http://s3.mediasourceinn.com',
  },
  demo_url: 'https://my-json-server.typicode.com/typicode/demo',
};

export default config;
